import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const educationService = {
  getAllEducation: async (params = {}) => {
    try {
      const response = await api.get(API_ENDPOINTS.EDUCATION, { params });
      return response;
    } catch (error) {
      throw error;
    }
  },
  createEducation: async (educationData) => {

    try {
      const response = await api.post(API_ENDPOINTS.EDUCATION, educationData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getEducationById: async (id) => {
    try {
      const response = await api.get(`${API_ENDPOINTS.EDUCATION}/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCategories: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.EDUCATION_CATEGORIES);
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateEducation: async (id, educationData) => {
    try {
      const response = await api.put(`${API_ENDPOINTS.EDUCATION}/${id}`, educationData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  isPublishEducation: async (id, payload) => {
    try {
      const response = await api.put(`${API_ENDPOINTS.EDUCATION_PUBLISH}/${id}`, payload);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getScripts: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.SCRIPT}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getTagSectors: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.TAG_SECTOR}`)
      return response;
    } catch (error) {
      throw (error)
    }
  },
  getTagIndustries: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.TAG_INDUSTRY}`)
      return response;
    } catch (error) {
      throw (error)
    }
  },
  getInternalTokens: async () => {
    try {
      const response = await api.get('/internaltoken/list');
      return response;
    } catch (error) {
      throw error;
    }
  },
  getUniqueGroupsByType: async (type) => {
    try {
      const response = await api.post('/graphql', {
        query: `
          query GetUniqueGroupsByType($type: String!) {
            getUniqueGroupsByType(type: $type)
          }
        `,
        variables: { type }
      });
      return response.data.getUniqueGroupsByType;
    } catch (error) {
      throw error;
    }
  },
  getUniqueCredits: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.EDUCATION}/credits`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getEducationImages: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.EDUCATION_IMAGES);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllNotificationTypes: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.EDUCATION_NOTIFICATION_TYPES);
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },

  sendNotification: async (payload) => {
    try {
      const response = await api.post("/notification/send", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

};
